
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import CustomTable from "@/components/CustomTable/index.vue";
import moment from "moment";
import {
  getCategoryStatistics,
  getCategoryStatisticsShop,
} from "@/api/shouyin";
import { Getter } from "vuex-class";

// 类别占比
@Component({
  components: {
    CardContainer,
    CustomTable,
  },
})
export class CategoryProportion extends Vue {
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;

  @Prop({ default: () => ({}) }) params!: any;
  isInit = false;
  columnsTree = [
    {
      key: "categoryName",
      title: "类别名称",
      width: 100,
      textOverflow: "ellipsis",
    },
    {
      key: "percentage",
      title: "占比",
      align: "left",
      dataType: "proportion",
    },
    {
      key: "yoyPercentage",
      title: "环比",
      align: "right",
      width: 80,
    },
    {
      key: "orderMoney",
      title: "销售金额",
      align: "right",
      width: 90,
      dataType: "amount",
    },
  ];
  tableDataSourceTree = [
    // {
    //   name: "类别1",
    //   percent: 0.4,
    //   ratio: "+10%",
    //   ratioStyle: this.getStyle(1),
    //   num: 2300,
    // },
    // {
    //   name: "类别2",
    //   percent: 0.5,
    //   ratio: "+10%",
    //   ratioStyle: this.getStyle(1),
    //   num: 2300,
    // },
    // {
    //   name: "类别3",
    //   percent: 0.6,
    //   ratio: "-10%",
    //   num: 2300,
    // },
    // {
    //   name: "类别4",
    //   percent: 0.6,
    //   ratio: "-10%",
    //   num: 2300,
    // },
    // {
    //   name: "类别类别类别",
    //   percent: 0.6,
    //   ratio: "+10%",
    //   ratioStyle: this.getStyle(1),
    //   num: 2300,
    // },
  ];

  getStyle(num = 1) {
    if (num > 0) {
      return {
        color: "#FD8305",
        fontSize: "12px",
      };
    }
    return { fontSize: "12px" };
  }

  @Watch("params", { deep: true, immediate: true })
  async onParamsChange() {
    this.isInit = false;
    const [prevQueryTimeBegin, prevQueryTimeEnd] = getYoytTime(this.params);
    const param: any = {
      ...this.params,
      queryType: this.params.orderType,
      categoryLevel: 1,
      prevQueryTimeBegin,
      prevQueryTimeEnd,
    };
    let res: any;
    if (this.isMultiStore) {
      param.storeList = this.multiStoreList.map((item) => {
        return { storeId: item };
      });
      res = await getCategoryStatisticsShop(param);
    } else {
      res = await getCategoryStatistics(param);
    }
    const data = res.data?.slice(0, 5) || [];
    data.forEach((item) => {
      const iszero = !item.yoyOrderMoney || item.yoyOrderMoney === 0;
      item.yoyPercentageStyle = this.getStyle(!iszero ? item.yoyPercentage : 0);
      item.yoyPercentage = iszero ? "--" : item.yoyPercentage + "%";
    });
    this.tableDataSourceTree = data;
    this.isInit = true;
  }
}
export default CategoryProportion;

// 获取环比时间
export function getYoytTime(params: any) {
  let timeType = params.timeType;
  let days;
  let yoyStartTime = "";
  let yoyEndTime = "";
  switch (timeType) {
    // 今日
    case 1:
      days = 1;
      break;
    // 昨日
    case 2:
      days = 1;
      break;
    // 本周
    case 3:
      days = 7;
      break;
    // 上周
    case 4:
      days = 7;
      break;
    // 自定义时间
    case 7:
      days =
        moment(params.queryTimeEnd).diff(
          moment(params.queryTimeBegin),
          "days"
        ) + 1;
      break;
    default:
      days = 0;
      break;
  }
  // 月环比
  if ([5, 6].includes(timeType)) {
    yoyStartTime = moment(params.queryTimeBegin)
      .subtract(1, "month")
      .startOf("month")
      .format("YYYY-MM-DD 00:00:00");
    yoyEndTime = moment(params.queryTimeEnd)
      .subtract(1, "month")
      .endOf("month")
      .format("YYYY-MM-DD 23:59:59");
  } else {
    yoyStartTime = moment(params.queryTimeBegin)
      .subtract(days, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    yoyEndTime = moment(params.queryTimeEnd)
      .subtract(days, "days")
      .format("YYYY-MM-DD HH:mm:ss");
  }
  return [yoyStartTime, yoyEndTime];
}
